const searchByName = (list, name) => {
  return list.find(x => x.__component === name)
}

export default {
  searchByName,
}
